import { Controller } from '@hotwired/stimulus'

// Connects to data-controller="open-modal-on-connect"
// Ouvre une page en modale à l'affichage : frame « modal » sur le web, visite dans
// l'app (path configuration). Le marqueur d'URL et l'élément sont retirés aussitôt,
// pour qu'un rechargement, un retour ou le cache Turbo ne la rouvrent pas.
export default class extends Controller {
  static values = { url: String, param: String, delay: { type: Number, default: 300 } }

  connect() {
    if (document.documentElement.hasAttribute('data-turbo-preview')) return

    const url = new URL(window.location.href)
    url.searchParams.delete(this.paramValue)
    window.history.replaceState(window.history.state, '', url)

    const modalUrl = this.urlValue
    this.element.remove()

    // Le temps de voir la page avant que la modale la recouvre.
    setTimeout(() => {
      const frame = document.querySelector('turbo-frame#modal')
      if (frame) {
        frame.src = modalUrl
      } else {
        window.Turbo.visit(modalUrl)
      }
    }, this.delayValue)
  }
}
